import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "infoPostModelSectionSelectionDv"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCard = _resolveComponent("ProfileCard")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { class: "scrollinfoDv" }, {
    default: _withCtx(() => [
      (_ctx.enhancedRelations.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enhancedRelations, (item) => {
              return (_openBlock(), _createBlock(_component_ProfileCard, {
                key: item._id,
                hideActions: false,
                fromOutside: _ctx.fromOutside,
                fromProfile: true,
                fromInfluncersPopup: false,
                userData: item,
                onOnCardClicked: _ctx.onProfileClicked
              }, null, 8, ["fromOutside", "userData", "onOnCardClicked"]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}